import axiosClient from "./axiosClient";

const commentApi = {
    getComments : (module, op, ref) => axiosClient.get(`/api/comment/list/${module}` + (op? (`/${op}` + (ref? `/${ref}` :``) ):``)),
    getCommentsSafely: (payload) => axiosClient.post(`/api/comment/getList`, payload),
    createComment: (payload) => axiosClient.post(`/api/comment`, payload),
};

export default commentApi;